import React from 'react'
import { useParams } from 'react-router'
// Component
import Select from './_Select'
import Detail from './_Detail'
// Additional
import { Phase } from 'helpers/app'
import { Routing } from 'helpers/routing'
import { SportsmanTeamMembershipContext } from 'components/SportsmanTeamMemberships/__SportsmanTeamMemberships.context'

const SportsmanTeamMembership: React.FC<Phase.Props> = (p) => {
  const params = useParams<Routing.SportsmanTeamMembershipParams>()

  return (
    <SportsmanTeamMembershipContext.Provider value={{ params: params }}>
      {p.phase === 'select' && <Select />}
      {p.phase === 'detail' && <Detail />}
    </SportsmanTeamMembershipContext.Provider>
  )
}

export default SportsmanTeamMembership
